import { FormControlLabel, Radio as MuiRadio, Typography } from '@mui/material';

type Props = {
  name: string;
  value: string | boolean;
  errorMessage?: string;
  onChange: (value: any) => void;
  defaultValue?: string;
  label?: string | JSX.Element;
};

export const RadioItem: React.FC<Props> = ({
  label,
  name,
  value,
  errorMessage,
  defaultValue,
  onChange
}) => {
  return (
    <FormControlLabel
      sx={{
        border: 'none',
        color: errorMessage ? 'error.main' : undefined
      }}
      control={
        <MuiRadio
          data-testid={`radio-${name}`}
          checked={Boolean(value)}
          onChange={(e) => onChange(e.target.checked)}
          defaultValue={defaultValue ?? ''}
        />
      }
      label={
        <Typography
          sx={{
            color: errorMessage ? 'error.main' : undefined
          }}
        >
          {label}
        </Typography>
      }
    />
  );
};
